import {AxiosRedirect} from "../axios.redirect";

let _URL = AxiosRedirect()

var axios = require('axios');
var qs = require('qs');
var data = qs.stringify({
    'client_id': _URL.clientID,
    'client_secret': _URL.clientSecret,
    'grant_type': _URL.grantType,
    'scope': _URL.scope
});

export default () => {
    let ax = axios.create({
        baseURL: _URL.Authority,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
        },
        data : data
    })
    ax.interceptors.response.use((response) => {
        return response
    }, (error) => {
        return error.response
    })
    return ax
}
